import * as Sentry from '@sentry/remix';
import { userStore } from '~/lib/stores/user';

export default async function checkTokenAccess(token: string, baseUrl: string) {
  return await Sentry.startSpan(
    {
      name: 'checkTokenAccessUtility',
      op: 'checkTokenAccessUtility',
    },
    async () => {
      const response = await fetch(`${baseUrl}/api/alpha/check-access?uuid=${token}`);

      if (response.ok) {
        const data = await response.json<{
          status: 'ACTIVE' | 'PENDING' | 'INACTIVE';
          email: string;
        }>();

        return { isActivated: data.status };
      } else {
        return { isActivated: 'FAILED' };
      }
    },
  );
}
